import React from 'react';
import { AssetUrls } from 'config/assets';
import './FoilCardImage.css';

interface FoilCardImageProps {
  src: string;
  alt: string;
  foil?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onError?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
  loading?: 'lazy' | 'eager';
  borderRadius?: string;
}

/**
 * FoilCardImage - A reusable card image component with optional foil overlay
 *
 * Renders a card image with an optional holographic foil sheen overlay
 * that matches the visual treatment on the ViewCardPage.
 */
export const FoilCardImage: React.FC<FoilCardImageProps> = ({
  src,
  alt,
  foil = false,
  className = '',
  style = {},
  onError,
  loading = 'lazy',
  borderRadius = '8px',
}) => {
  return (
    <div
      className={`foil-card-image-wrapper ${className}`}
      style={{
        ...style,
        borderRadius,
      }}
    >
      <img
        src={src}
        alt={alt}
        className="foil-card-image"
        style={{ borderRadius }}
        onError={onError}
        loading={loading}
      />
      {foil && (
        <img
          src={`${AssetUrls.base}/assets/view-card/foil-overlay.svg`}
          alt=""
          className="foil-card-overlay"
          style={{ borderRadius }}
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default FoilCardImage;
